import AssetActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  dataIn:{},
  dataOut:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperAsset:null,
  helperFullAsset:null,
  errorInternal:false
};

function AssetReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AssetActions.RESET_LIST:
      return INITIAL_STATE;
    case AssetActions.NEW_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case AssetActions.UPDATE_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, single:null,isNewRecord:false};
    case AssetActions.VIEW_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case AssetActions.VIEW_DATA_IN:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, dataIn:action.payload,isNewRecord:false,showModalIn:true};
    case AssetActions.VIEW_DATA_OUT:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, dataOut:action.payload,isNewRecord:false,showModalOut:true};
    case AssetActions.RESET_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case AssetActions.DELETE_DATA:
      return { ...state, errorInternal:false, onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case AssetActions.ON_SUBMIT:
      return { ...state,errorInternal:false, onSubmit:true};
    case AssetActions.SHOW_DATA:
      return { ...state, errorInternal:false, onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case AssetActions.SUCCESS_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case AssetActions.ERROR_DATA:
      return { ...state, onSubmit:false, errorInternal:false,  isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case AssetActions.PROCESS_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: true, isError: false,isSuccess:false};
    case AssetActions.GET_HELPER_ASSET:
      return { ...state, errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperAsset:action.payload};
    case AssetActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case AssetActions.VOID_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, form:INITIAL_STATE.form};
       
    default:
      return state;
    }
}

export default AssetReducer;
